import { guid } from "@fullcalendar/core/internal";

export const avobboxtext = {
    id: "Identifiant",
    name: "Nom",
    description: "Description",
    type: "Type",
    group: "Entité",
    version: "Version",
    lastconnection: "Dernière connexion",
    iotconnector: "Connecteur IoT",
    servertype: "Type de serveur",
    gatewayid: "Identifiant",
    address: "Adresse",
    uniqueid: "GUID",
    lorawanstate: "Etat LoRaWAN",
    sessionstate: "Etat des sessions",
    diskspace: "Espace disque",
    diskusage: "Espace disque utilisé",
    healthanalyse: "Synthèse d'état",
    lorawangatewaydown: "Nombre de passerelles LoRaWAN déconnectées",
    lorawangatewayup: "Nombre de passerelles LoRaWAN connectées",
    sessiondown: "Nombre de sessions déconnectées",
    sessionup: "Nombre de sessions connectées",
    chirpstackrestapi: "chirpstack-rest-api",
    chirpstackapp: "chirpstack-app",
    chirpstackbridge: "chirpstack-bridge",
    postgres: "postgres",
    lorawangateway: "Passerelles LoRaWAN",
    lasthealthdate: "Dernier état",
    push: "Synchroniser",
    delete: "Supprimer la box",
    edit: "Editer la box",
    euid: "EUID",
    gatewayhardware: "Matériel",
    server: "Serveur",
}

export const serverTypeBoxCreationData = [
    { name: "Serveur LoRaWAN AVOB", id: "avoblorawanserver"},
];